import { Component, EventEmitter, Input, Output } from '@angular/core';
import { enumLclCardStyle } from '@shared/lcl-mutual/enums';

@Component({
  selector: 'app-lcl-card',
  template: `
    <div class="lcl-data-card" [ngClass]="{ 'is-equal': isEqual, 'is-light': isLightStyle }">
      <div class="lcl-data-card-header" [ngClass]="{ warning: isWarningHeader }">
        <div class="lcl-data-card-header-info">
          <div class="w-100 d-flex align-items-center justify-content-between" [ngClass]="{ 'flex-column flex-md-row': isRowOnMobile }">
            <div class="d-flex align-items-center">
              <h3 class="mr-1">
                {{ cardTitle | translate }}
                <ng-content select="[header-label]"></ng-content>
              </h3>

              <app-hint-tooltip-icon [hint]="cardHint" *ngIf="!!cardHint"></app-hint-tooltip-icon>
            </div>

            <div class="d-flex justify-content-between m-2 m-md-0">
              <button type="button" class="btn btn-link d-print-none" *ngIf="isCanEdit" (click)="edit.emit()">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
                    fill="currentColor"
                  />
                </svg>

                <span class="ml-1">{{ 'BUTTON.EDIT' | translate }}</span>
              </button>

              <ng-content select="[header-actions-button]"></ng-content>
            </div>

            <ng-content select="[header]"></ng-content>
          </div>
        </div>
      </div>

      <div class="lcl-data-card-body">
        <ng-content select="[body]"></ng-content>
      </div>

      <div class="lcl-data-card-footer">
        <ng-content select="[footer]"></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./lcl-card.component.scss'],
})
export class LclCardComponent {
  @Input() public cardTitle: string;
  @Input() public cardHint: string;
  @Input() public isRowOnMobile: boolean;
  @Input() public isCanEdit: boolean;
  @Input() public isEqual: boolean;
  @Input() public isWarningHeader: boolean;
  @Input() public cardStyle: enumLclCardStyle = enumLclCardStyle.DEFAULT;

  @Output() public edit: EventEmitter<void> = new EventEmitter<void>();

  public get isLightStyle(): boolean {
    return this.cardStyle === enumLclCardStyle.LIGHT;
  }
}
